/// <reference path="../../../../typings/index.d.ts" />

module Meevo.AuditHistory {
    export class AuditHistoryController {

        static $inject = [
            "$mdDialog",
            "auditLog",
            "userId",
            //"auditcreatedrecord",
            "userName"
        ];

        constructor(
            private $mdDialog: angular.material.IDialogService,
            protected auditLog = [],
            protected userId: any,
            //protected auditcreatedrecord: any,
            protected userName: any) {

            var user = this.userId;
            var log = this.auditLog;

        }

        close() {
            this.$mdDialog.hide();
        }

    }

    angular.module("meevo")
        .controller("meevo.auditHistory.AuditHistoryController", AuditHistoryController);
}

